<arcgis-map
  [aria]="{
    label: 'Elvia strømbruddskart',
    description: 'Kart over strømbrudd og planlagte strømstanser i Elvias nettområde.',
  }"
  [map]="mapConfig"
  popup-disabled
  [center]="[11.1, 60.7]"
  zoom="4"
  [constraints]="{
    minZoom: 3,
    maxZoom: 19,
    rotationEnabled: false,
  }"
  [navigation]="navigation()"
  (arcgisViewReadyChange)="setLoadingStateOnViewReady()"
  (arcgisViewClick)="selectOutageAtClick($event)"
  id="map"
  #map />

@if (this.isScrolling() && !this.isHoldingZoomKey()) {
  <div class="zoom-guide">
    @let key = isMac ? '⌘' : 'Ctrl';
    <p class="e-title-sm">Hold {{ key }}-knappen og rull for å zoome på kartet</p>
  </div>
}
